<circ-loader *ngIf="loading"></circ-loader>
<circulation-dialog
  [title]="'task.nodocument.dialog.title'"
  [content]="'task.nodocument.dialog.content'"
  [(opened)]="addDocumentsDialogOpened"
  (dialogClosed)="onAddDocumentsDialogClosed($event)"
  ></circulation-dialog>
<ng-container *ngIf="!loading">
  <h3>{{ 'step_forConfirmation_new_name' | i18n }}</h3>
  <h4>{{ title }}</h4>
  <p class="comment">{{ comment }}</p>
  <form class="k-form" [formGroup]="form">
    <fieldset class="k-form-fieldset">
      <kendo-formfield showHint="initial" showErrors="initial">
        <kendo-label [for]="workComment" [text]=" 'step_work_label_comment' | i18n "></kendo-label>
        <textarea kendoTextArea formControlName="workComment" #workComment required></textarea>
        <kendo-formhint>{{ 'step_work_formhint_comment' | i18n }}</kendo-formhint>
        <kendo-formerror>
        </kendo-formerror>
      </kendo-formfield>
      <div class="k-form-buttons">
        <ece-btn-primary [disabled]="disabled" (click)="accept()" [text]="'step_forConfirmation_work_approve' | i18n"></ece-btn-primary>
        <ece-btn [disabled]="disabled" (click)="decline()"[text]="'step_forConfirmation_work_decline' | i18n "></ece-btn>
      </div>
    </fieldset>
  </form>
</ng-container>
